import i18n from '../../i18n';

export const ui = {
    namespaced: true,
    state: {
        notification: {
            display: false,
        },
    },
    getters: {
        notification: state => {
            return state.notification;
        },
    },
    mutations: {
        set_notification: (state, { display, code, alertClass }) => {
            state.notification.display = display
            state.notification.text = (/[a-z]/.test(code) ? code : i18n.t('Responses.' + code))
            state.notification.title = alertClass == 'success' ? i18n.t('Responses.SUCCESS') : i18n.t('Responses.ERROR')
            state.notification.class = alertClass
            state.notification.icon = alertClass == 'success'? 'mdi-check' : 'mdi-alert-circle'
        }
    }
};